import { CopyText } from '../i18n/Language';
import { localizeUrl, useLanguage } from '../i18n/Language';
import { Link } from '../i18n/Language';
import { studio, appsUrl } from '../data/studio';

export default function Footer() {
  const { t, language } = useLanguage();
  return (
    <footer className="studio-footer">
      <div className="studio-container footer-row">
        <div className="footer-brand">
          <Link to="/" className="wordmark"><img className="brand-symbol brand-symbol-small" src="/images/liminality-mark-alt.png" alt="" />LIMINALITY</Link>
          <span>· {new Date().getFullYear()}{' '}<CopyText source={"· Naples, Italy"} /></span>
        </div>
        <nav aria-label={t("Footer navigation")}>
          <Link to="/journal"><CopyText source={"Journal"} /></Link>
          <a href={localizeUrl(appsUrl, language)}><CopyText source={"Apps"} /></a>
          <Link to="/contact"><CopyText source={"Contact"} /></Link>
          <a href={`mailto:${studio.email}`}>{studio.email}</a>
        </nav>
      </div>
    </footer>
  );
}
